import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';

const styles = css`
  .HomeText {
    padding: 10px 0;
    width: 100%;
    @media (min-width: 992px) {
      padding: 30px 15px;
    }
  }
  .HomeText_title {
    text-align: center;
    font-size: 46px;
    font-weight: 200;
    line-height: 1;
    color: ${colors.color1};
    text-transform: uppercase;
    span {
      display: inline-block;
      width: 100%;
    }
    @media (min-width: 992px) {
      font-size: 80px;
      font-weight: 300;
      line-height: 0.75;
    }
  }
  .Hometext_welcome {
    color: ${colors.color2};
    font-size: 21px;
    font-weight: bold;
    line-height: 1.5;
  }
  .Hometext_builder {
    font-size: 35px;
    font-family: ${typography.Serif};
    @media (min-width: 992px) {
      font-size: 48px;
    }
  }
  .HomeText_postTitle {
    font-size: 15px;
    color: #4A4A4A;
    letter-spacing: 1px;
    text-transform: none;
    font-family: ${typography.Serif};
    @media (min-width: 992px) {
      font-size: 21px;
    }
  }
  .HomeText_divider {
    border-top: 5px solid ${colors.color2};
    width: 180px;
  }
  .HomeText_body {
    text-align: center;
    font-size: 14px;
    line-height: 25px;
    color: ${colors.color1};
    font-weight: 300;
    margin: 0 0 25px 0;
    display: none;
    @media (min-width: 992px) {
      font-size: 24px;
      line-height: 40px;
      display: block;
    }
  }
`;

function MainCopy({ page, builder }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="HomeText">
          <h1 className="HomeText_title">
            <span className="Hometext_welcome">{get(page, 'lead_copy[0].title')}</span>
            <span className="Hometext_builder">{get(builder, 'name')}</span>
            <span className="HomeText_postTitle">{get(page, 'lead_copy[0].subtitle')}</span>
          </h1>
          <hr className="HomeText_divider" />
          <div className="HomeText_body" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'lead_copy[0].body'))} />
        </div>
      </div>
    </div>
  );
}

MainCopy.propTypes = {
  page: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
};

export default withData({
  page: 'home_page',
  builder: true,
})(MainCopy);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/MainCopy.js